export class DataCatalogTagExpression {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "anyOf",
            "baseName": "anyOf",
            "type": "Array<DataCatalogTagConjunction>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTagExpression.attributeTypeMap;
    }
    constructor() {
    }
}
